/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmbulanzType } from './AmbulanzType';
import {
    AmbulanzTypeFromJSON,
    AmbulanzTypeFromJSONTyped,
    AmbulanzTypeToJSON,
    AmbulanzTypeToJSONTyped,
} from './AmbulanzType';

/**
 * 
 * @export
 * @interface AmbulanzResponse
 */
export interface AmbulanzResponse {
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    ambulanzId: string;
    /**
     * 
     * @type {AmbulanzType}
     * @memberof AmbulanzResponse
     */
    type: AmbulanzType;
    /**
     * 
     * @type {Date}
     * @memberof AmbulanzResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    ambulanzNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    clientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    clientFullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmbulanzResponse
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    assignedCounselorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmbulanzResponse
     */
    assignedCounselorCode?: string | null;
}



/**
 * Check if a given object implements the AmbulanzResponse interface.
 */
export function instanceOfAmbulanzResponse(value: object): value is AmbulanzResponse {
    if (!('ambulanzId' in value) || value['ambulanzId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function AmbulanzResponseFromJSON(json: any): AmbulanzResponse {
    return AmbulanzResponseFromJSONTyped(json, false);
}

export function AmbulanzResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmbulanzResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ambulanzId': json['ambulanzId'],
        'type': AmbulanzTypeFromJSON(json['type']),
        'createdAt': (new Date(json['createdAt'])),
        'ambulanzNumber': json['ambulanzNumber'] == null ? undefined : json['ambulanzNumber'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'note': json['note'] == null ? undefined : json['note'],
        'clientFullName': json['clientFullName'] == null ? undefined : json['clientFullName'],
        'isCompleted': json['isCompleted'] == null ? undefined : json['isCompleted'],
        'assignedCounselorId': json['assignedCounselorId'] == null ? undefined : json['assignedCounselorId'],
        'assignedCounselorCode': json['assignedCounselorCode'] == null ? undefined : json['assignedCounselorCode'],
    };
}

export function AmbulanzResponseToJSON(json: any): AmbulanzResponse {
    return AmbulanzResponseToJSONTyped(json, false);
}

export function AmbulanzResponseToJSONTyped(value?: AmbulanzResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ambulanzId': value['ambulanzId'],
        'type': AmbulanzTypeToJSON(value['type']),
        'createdAt': value['createdAt'].toISOString(),
        'ambulanzNumber': value['ambulanzNumber'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'phone': value['phone'],
        'email': value['email'],
        'note': value['note'],
        'clientFullName': value['clientFullName'],
        'isCompleted': value['isCompleted'],
        'assignedCounselorId': value['assignedCounselorId'],
        'assignedCounselorCode': value['assignedCounselorCode'],
    };
}

